module.exports = __webpack_public_path__ + "static/p2-4ca346d07ffa9e31678890f04bc23559.jpg";